var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 30.5293H4C1.79098 30.5293 0 28.7383 0 26.5293V6.84229C0 4.6333 5.79102 0.529297 8 0.529297H28.625C31.719 0.529297 34 2.84131 34 5.90431V26.5293C34 28.7383 32.209 30.5293 30 30.5293Z",
    fill: "#C1694F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 34.5297H5.99999C3.791 34.5297 2 32.7387 2 30.5296V6.52966C2 2.41064 1.979 2.52965 7.00001 2.52965H28C30.209 2.52965 32 4.32064 32 6.52966V30.5296C32 32.7387 30.209 34.5297 28 34.5297Z",
    fill: "#CCD6DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 34.5293H3C1.34301 34.5293 0 33.1863 0 31.5293V7.5293C0 5.87231 1.34301 4.5293 3 4.5293H27C28.657 4.5293 30 5.87231 30 7.5293V31.5293C30 33.1863 28.657 34.5293 27 34.5293Z",
    fill: "#E1E8ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 36.5293H5C2.79101 36.5293 1 34.7383 1 32.5293V10.5293C1 8.3203 2.79101 6.5293 5 6.5293H26C28.209 6.5293 30 8.3203 30 10.5293V32.5293C30 34.7383 28.209 36.5293 26 36.5293Z",
    fill: "#C1694F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 36.5293H5C2.79099 36.5293 1 34.7383 1 32.5293V12.5293C1 10.3203 2.79099 8.5293 5 8.5293H24.335C26.544 8.5293 28 9.9853 28 12.1943V32.5293C28 34.7383 26.209 36.5293 24 36.5293Z",
    fill: "#D99E82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.7793C4.832 2.8383 6.125 2.52931 8.438 2.52931H10V0.529297H7.281C3.312 0.529297 0 3.02928 0 5.90431V32.5293C0 34.7383 1.791 36.5293 4 36.5293H6V6.52931H5C3.312 6.52931 3.269 4.60731 4 3.7793Z",
    fill: "#C1694F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20.5293H12C10.896 20.5293 10 19.6333 10 18.5293V16.5293C10 15.4253 10.896 14.5293 12 14.5293H22C23.104 14.5293 24 15.4253 24 16.5293V18.5293C24 19.6333 23.104 20.5293 22 20.5293Z",
    fill: "#E1E8ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.45e2170a049e27baa3e5f02113c5769a.svg";
export { ForwardRef as ReactComponent };